export default "__VITE_ASSET__DwXX5J25__"